import { StyleSheet } from 'react-native';

import { moderateScale } from '@utils/scaling';

export const styles = StyleSheet.create({
  text: {
    marginVertical: moderateScale(8),
  },
});
